<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  <!-- Primera carga: tabla Skeleton -->
  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="14rem" height="0.875rem" />
          </div>
          <div class="w-full sm:w-auto flex justify-end">
            <p-skeleton width="10rem" height="2.5rem" />
          </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Folio</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Cliente</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Estado</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600 hidden sm:table-cell">Método de cobro</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600 hidden sm:table-cell">Suscripción</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">F. creación</th>
              <th class="px-2 py-2 text-center text-sm font-semibold text-slate-600">Vigencia</th>
              <th class="px-2 py-2 text-right text-sm font-semibold text-slate-600">Subtotal</th>
              <th class="px-2 py-2 text-right text-sm font-semibold text-slate-600">Total</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2">
                  <div class="flex items-center gap-2">
                    <p-skeleton shape="circle" size="2.5rem" />
                    <div class="min-w-0">
                      <p-skeleton width="7rem" height="0.875rem" />
                      <p-skeleton width="5rem" height="0.75rem" class="mt-1" />
                    </div>
                  </div>
                </td>
                <td class="px-2 py-2">
                  <p-skeleton width="8rem" height="0.875rem" />
                  <p-skeleton width="5rem" height="0.75rem" class="mt-1" />
                </td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="1.25rem" /></td>
                <td class="px-2 py-2 hidden sm:table-cell"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 hidden sm:table-cell"><p-skeleton width="5rem" height="1.25rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="8rem" height="1.25rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="4rem" height="2rem" /></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-between items-center shrink-0">
        <p-skeleton width="8rem" height="2rem" />
        <p-skeleton width="12rem" height="2rem" />
      </div>
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        (click)="loadSales()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  <!-- Tabla PrimeNG: siempre visible tras primera carga (con filtros) para poder seguir filtrando aunque no haya resultados -->
  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr] items-center gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-file-edit"></i>
                </span>
                Ventas
              </h2>
              <p class="text-sm text-slate-500 mt-1">Catálogo de Ventas emitidas.</p>
            </div>
            <span class="inline-flex justify-self-center rounded-lg border border-slate-200 bg-white p-0.5 shadow-sm" role="group" aria-label="Tipo de vista">
              <button
                type="button"
                class="inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-xs font-medium transition-colors"
                [class.bg-sky-100]="viewMode() === 'table'"
                [class.text-sky-800]="viewMode() === 'table'"
                [class.text-slate-600]="viewMode() !== 'table'"
                (click)="setViewMode('table')"
                pTooltip="Vista tabla"
                tooltipPosition="bottom"
              >
                <i class="pi pi-table"></i>
                <span class="hidden sm:inline">Tabla</span>
              </button>
              <button
                type="button"
                class="inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-xs font-medium transition-colors"
                [class.bg-sky-100]="viewMode() === 'kanban'"
                [class.text-sky-800]="viewMode() === 'kanban'"
                [class.text-slate-600]="viewMode() !== 'kanban'"
                (click)="setViewMode('kanban')"
                pTooltip="Vista Kanban por embudo (processStatus)"
                tooltipPosition="bottom"
              >
                <i class="pi pi-th-large"></i>
                <span class="hidden sm:inline">Kanban</span>
              </button>
            </span>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              <p-button
                label="Actualizar"
                icon="pi pi-refresh"
                severity="secondary"
                size="small"
                [rounded]="true"
                [loading]="loading()"
                (onClick)="refreshTable()"
                pTooltip="Actualizar listado con los filtros y página actuales"
                tooltipPosition="left"
                appendTo="body" />
              <a routerLink="/sales/nuevo" class="inline-block" appDisableUnless="SALE_WRITE">
                <p-button label="Nueva Venta" icon="pi pi-plus" severity="primary" size="small" appDisableUnless="SALE_WRITE" />
              </a>
            </div>
          </div>
        </div>

        <!-- Filtros -->
        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
            <div class="min-w-0 xl:w-36">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <input pInputText id="filterSalesNumber" formControlName="number" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.number.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.number.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterSalesNumber">Folio</label>
              </p-floatlabel>
            </div>
            <div class="min-w-0 col-span-2 sm:col-span-1 xl:flex-1 xl:min-w-40">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <p-inputicon class="pi pi-search text-sm" />
                  <input pInputText id="filterSalesQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.q.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.q.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterSalesQ">Cliente o RFC</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 xl:w-36" variant="on">
              <p-select
                formControlName="isStamped"
                inputId="filterSalesStamped"
                [options]="stampedFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterSalesStamped">Facturada</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-64" variant="on">
              <p-datepicker
                inputId="filterSalesCreatedAt"
                formControlName="createdAtRange"
                selectionMode="range"
                [readonlyInput]="true"
                dateFormat="dd/mm/yy"
                showIcon
                iconDisplay="input"
                [showClear]="true"
                size="small"
                class="w-full" />
              <label for="filterSalesCreatedAt">Rango F. creación</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 xl:w-32" variant="on">
              <p-select
                formControlName="state"
                inputId="filterSalesState"
                [options]="stateFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterSalesState">Estatus</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end col-span-2 sm:col-span-1">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        @if (viewMode() === 'table') {
        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            #dtInvoices
            [value]="sales()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Ventas"
            [loading]="loading()"
            [paginator]="true"
            sortMode="single"
            [sortField]="sortField()"
            [sortOrder]="sortOrder()"
            (onLazyLoad)="onLazyLoad($event)"
            [tableStyle]="{ width: '100%' }"
            styleClass="sales-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !items-center !justify-between"
          >
            <ng-template pTemplate="paginatorleft">
              <span
                class="inline-flex"
                [pTooltip]="exportButtonTooltip"
                tooltipPosition="top"
                appendTo="body">
                <p-button
                  label="Exportar CSV"
                  icon="pi pi-download"
                  severity="secondary"
                  size="small"
                  [rounded]="true"
                  [loading]="exporting()"
                  [disabled]="!canExportSales || exporting() || totalItems() === 0"
                  (onClick)="exportCsv()" />
              </span>
            </ng-template>
            <ng-template pTemplate="header">
              <tr class="">
                <th class="!px-2" pSortableColumn="number">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Folio</span>
                    @if (sortField() === 'number') {
                      <p-sortIcon field="number" />
                    }
                  </span>
                </th>
                <th class="!px-2" pSortableColumn="customer.comercialName">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Cliente</span>
                    @if (sortField() === 'customer.comercialName') {
                      <p-sortIcon field="customer.comercialName" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="status">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Estado</span>
                    @if (sortField() === 'status') {
                      <p-sortIcon field="status" />
                    }
                  </span>
                </th>
                <th class="!px-2 hidden sm:table-cell !whitespace-nowrap" pSortableColumn="collectionMethod">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Método de cobro</span>
                    @if (sortField() === 'collectionMethod') {
                      <p-sortIcon field="collectionMethod" />
                    }
                  </span>
                </th>
                <th class="!px-2 hidden sm:table-cell !whitespace-nowrap sales-col-subscription">Suscripción</th>
                <th class="!px-2 !whitespace-nowrap !text-center" pSortableColumn="createdAt">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>F. creación</span>
                    @if (sortField() === 'createdAt') {
                      <p-sortIcon field="createdAt" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-center sales-col-validity" pSortableColumn="collectionStartDate">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Vigencia</span>
                    @if (sortField() === 'collectionStartDate') {
                      <p-sortIcon field="collectionStartDate" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right" pSortableColumn="subtotal">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Subtotal</span>
                    @if (sortField() === 'subtotal') {
                      <p-sortIcon field="subtotal" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right" pSortableColumn="total">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Total</span>
                    @if (sortField() === 'total') {
                      <p-sortIcon field="total" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-sale>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100" (click)="openSaleDetails(sale)">
                <td class="!px-2 !py-2 !border-slate-100">
                  <div class="flex items-center gap-2">
                    <div class="relative shrink-0 h-8 w-8 overflow-visible">
                      <div
                        [class]="getStatusIconClasses(sale) + ' !h-8 !w-8 [&>i]:text-sm'"
                        [pTooltip]="isSaleInactive(sale) ? 'Inactivo' : getStatusLabel(sale.status)"
                        tooltipPosition="top"
                      >
                        <i [class]="getStatusIcon(sale)"></i>
                      </div>
                      @if (isSaleStamped(sale)) {
                        <span
                          class="sale-stamped-badge pointer-events-auto absolute -bottom-1 -right-1 z-0 h-4 w-4 rounded-full bg-emerald-500 text-white ring-2 ring-white shadow"
                          pTooltip="Facturada"
                          tooltipPosition="bottom"
                        >
                          <i class="pi pi-check !text-[9px]"></i>
                        </span>
                      }
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ sale.number || '—' }}</div>
                      @if (sale.paymentReference) {
                        <span class="block text-[11px] text-slate-400 mt-0.5 font-mono truncate">{{ sale.paymentReference }}</span>
                      }
                      @if (sale.saleType) {
                        <span class="block text-[11px] text-slate-400 mt-0.5 font-normal">{{ getSaleTypeLabel(sale.saleType) }}</span>
                      }
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 max-w-[12rem]">
                  <div class="min-w-0">
                    <div
                      class="text-sm text-slate-900 truncate"
                      [pTooltip]="sale.customer?.comercialName || sale.customer?.legalName || ''"
                      tooltipPosition="top"
                    >{{ sale.customer?.comercialName || sale.customer?.legalName || '-' }}</div>
                    <div class="text-xs text-slate-500 truncate">{{ sale.customer?.taxId || '' }}</div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap">
                  <div class="flex flex-col gap-1 items-start">
                    <p-tag class="!text-xs" severity="secondary" [value]="getStatusLabel(sale.status)" />
                    @if (sale.status !== 'DRAFT' && sale.delinquencyStatus && sale.delinquencyStatus !== 'CURRENT') {
                      <p-tag
                        class="!text-xs"
                        [value]="getDelinquencyLabel(sale.delinquencyStatus)"
                        [severity]="getDelinquencySeverity(sale.delinquencyStatus) ?? undefined"
                      />
                    }
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell text-sm text-slate-600 !whitespace-nowrap">
                  {{ getCollectionMethodLabel(sale.collectionMethod) }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell sales-col-subscription" (click)="$event.stopPropagation()">
                  @if (sale.subscription?.id; as subId) {
                    <button
                      type="button"
                      class="inline-flex max-w-full items-center gap-1 rounded border border-teal-200 bg-teal-50 px-1.5 py-0.5 text-[10px] font-medium text-teal-800 transition hover:border-teal-300 hover:bg-teal-100"
                      (click)="openSubscriptionDetails(subId)"
                      [pTooltip]="sale.subscription?.number || ''"
                      tooltipPosition="top"
                    >
                      <span class="truncate">{{ sale.subscription?.number || '—' }}</span>
                      <i class="pi pi-arrow-up-right shrink-0 text-teal-500 text-[9px]"></i>
                    </button>
                  } @else {
                    <span class="text-xs text-slate-400">—</span>
                  }
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap !text-center">
                  @if (sale.createdAt) {
                    <div class="text-sm text-slate-600">{{ sale.createdAt | date:'dd/MM/yyyy' }}</div>
                    <div class="text-[11px] text-slate-400 mt-0.5">{{ sale.createdAt | date:'h:mm a' }}</div>
                  } @else {
                    <span class="text-sm text-slate-600">-</span>
                  }
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap sales-col-validity">
                  @if (saleCollectionValidity(sale); as validity) {
                    <ng-container *ngTemplateOutlet="collectionValidityBar; context: { $implicit: validity }" />
                  } @else {
                    <span class="block text-center text-sm text-slate-700">-</span>
                  }
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right">
                  {{ (sale.subtotal ?? 0) | number:'1.2-2' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right">
                  {{ (sale.total ?? 0) | number:'1.2-2' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap" (click)="$event.stopPropagation()" pFrozenColumn>
                  <span class="inline-flex items-center gap-0.5">
                    <p-button icon="pi pi-pen-to-square" rounded [text]="true" severity="secondary" styleClass="hover:!bg-sky-100" (onClick)="editSale(sale, $event)" appDisableUnless="SALE_WRITE" />
                  </span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="10" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No se encontraron Ventas con los filtros aplicados.
                </td>
              </tr>
            </ng-template>
          </p-table>
          <ng-template #collectionValidityBar let-validity>
            <div class="flex w-full min-w-0 flex-col gap-1">
              <div class="flex items-center justify-between gap-1.5 text-[11px]" [class.text-slate-500]="!validity.expired" [class.text-red-600]="validity.expired">
                <span>{{ validity.start | date:'dd/MM/yyyy' }}</span>
                <span class="inline-flex items-center gap-1" [class.font-medium]="validity.expired">
                  <span>{{ validity.due | date:'dd/MM/yyyy' }}</span>
                  @if (validity.expired) {
                    <i
                      class="pi pi-exclamation-circle text-xs"
                      [pTooltip]="overdueTooltip(validity.due)"
                      tooltipPosition="top"
                    ></i>
                  }
                </span>
              </div>
              <div class="relative h-3 w-full">
                <div
                  class="absolute inset-x-0 top-1/2 h-1.5 -translate-y-1/2 overflow-hidden rounded-full bg-slate-200"
                  role="progressbar"
                  [attr.aria-valuenow]="validity.percent"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  [pTooltip]="validity.remainingLabel"
                  tooltipPosition="top"
                >
                  <div class="h-full rounded-full transition-all" [class]="validity.barClass" [style.width.%]="validity.percent"></div>
                </div>
                @if (validity.paidAt != null && validity.paidMarkerPercent != null) {
                  <span
                    class="absolute top-1/2 z-10 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-emerald-600 shadow-sm"
                    [style.left.%]="validity.paidMarkerPercent"
                    [pTooltip]="'Pagada el ' + (validity.paidAt | date:'dd/MM/yyyy')"
                    tooltipPosition="top"
                    role="img"
                    [attr.aria-label]="'Pagada el ' + (validity.paidAt | date:'dd/MM/yyyy')"
                  ></span>
                }
              </div>
            </div>
          </ng-template>
        </div>
        }

        @if (viewMode() === 'kanban') {
          <div class="flex-1 min-h-0 flex flex-col overflow-hidden px-4 py-4 border-t border-slate-100 bg-slate-50/40">
            <div cdkDropListGroup class="sales-kanban-board flex-1 min-h-0 flex gap-3 overflow-x-auto pb-2">
              @for (col of pipelineStatusOptions; track col.value) {
                @let column = kanbanColumnState(col.value);
                <div
                  class="flex-shrink-0 w-72 flex flex-col rounded-xl border border-slate-200 bg-slate-50/80 h-full min-h-0"
                >
                  <div class="px-3 py-2.5 border-b border-slate-200 bg-white/90 rounded-t-xl rounded-b-none">
                    <p class="text-xs font-semibold text-slate-600 uppercase tracking-wide">{{ col.label }}</p>
                    <p class="text-[11px] text-slate-400 mt-0.5">
                      @if (column.totalItems > column.items.length) {
                        {{ column.items.length }} de {{ column.totalItems }} ventas
                      } @else {
                        {{ column.totalItems }} ventas
                      }
                    </p>
                  </div>
                  <div
                    cdkDropList
                    cdkScrollable
                    [id]="'kanban-col-' + col.value"
                    [cdkDropListData]="column.items"
                    (cdkDropListDropped)="onKanbanDrop($event, col.value)"
                    (scroll)="onKanbanColumnScroll($event, col.value)"
                    class="flex-1 overflow-y-auto p-2 space-y-2 min-h-[200px]"
                  >
                    @if (column.loading && column.items.length === 0) {
                      @for (sk of kanbanColumnSkeletonRows; track sk) {
                        <div class="rounded-lg border border-slate-200 bg-white p-3 space-y-2">
                          <p-skeleton width="100%" height="0.75rem" />
                          <p-skeleton width="60%" height="0.75rem" />
                          <p-skeleton width="40%" height="1rem" class="mt-2" />
                        </div>
                      }
                    }
                    @for (sale of column.items; track sale.id) {
                      <div
                        cdkDrag
                        [cdkDragData]="sale"
                        [cdkDragDisabled]="isKanbanDragDisabled(sale)"
                        (cdkDragStarted)="onKanbanDragStarted()"
                        (cdkDragEnded)="onKanbanDragEnded()"
                        (click)="onKanbanCardClick(sale)"
                        class="sales-kanban-card flex flex-col rounded-lg border border-slate-200 bg-white p-3 pb-0 shadow-sm hover:shadow transition-shadow cursor-pointer overflow-hidden"
                      >
                        <div class="flex items-start justify-between gap-2">
                          <div class="min-w-0 flex-1">
                            <p
                              class="text-xs font-semibold text-slate-900 truncate"
                              [pTooltip]="sale.customer?.comercialName || sale.customer?.legalName || ''"
                              tooltipPosition="top"
                            >
                              {{ sale.customer?.comercialName || sale.customer?.legalName || '—' }}
                            </p>
                            <p class="text-xs text-slate-500 font-mono tabular-nums truncate mt-0.5">
                              {{ sale.number || '—' }}
                            </p>
                          </div>
                          <div class="relative shrink-0 h-5 w-5 overflow-visible">
                            <div
                              [class]="getStatusIconClasses(sale)"
                              class="h-5 w-5 shrink-0 rounded-full flex items-center justify-center [&>i]:text-sm"
                              [pTooltip]="isSaleInactive(sale) ? 'Inactivo' : getStatusLabel(sale.status)"
                              tooltipPosition="top"
                            >
                              <i [class]="getStatusIcon(sale)"></i>
                            </div>
                            @if (isSaleStamped(sale)) {
                              <span
                                class="sale-stamped-badge absolute -bottom-1 -right-1 z-10 h-3.5 w-3.5 rounded-full bg-emerald-500 text-white ring-2 ring-white shadow"
                                pTooltip="Facturada"
                                tooltipPosition="bottom"
                              >
                                <i class="pi pi-check !text-[8px]"></i>
                              </span>
                            }
                          </div>
                        </div>
                        <p class="text-slate-900 text-sm font-medium mt-2">
                          {{ (sale.total ?? 0) | number:'1.2-2' }}
                        </p>
                        @let dq = getKanbanDelinquencyFooter(sale);
                        <div
                          class="mt-2 -mx-3 flex min-w-0 shrink-0 items-center justify-between gap-2 self-stretch border-t px-3 py-2 text-[11px] font-medium"
                          [ngClass]="{
                            'bg-red-50 text-red-700 border-red-100': dq.tone === 'red',
                            'bg-emerald-50 text-emerald-800 border-emerald-100': dq.tone === 'green',
                            'bg-amber-50 text-amber-900 border-amber-100': dq.tone === 'amber',
                            'bg-slate-50 text-slate-600 border-slate-100': dq.tone === 'neutral'
                          }"
                        >
                          <div class="flex min-w-0 flex-1 items-center gap-1.5">
                            <i class="pi pi-info-circle shrink-0 text-[10px] opacity-80"></i>
                            <span class="leading-snug">{{ dq.text }}</span>
                          </div>
                          <p-tag
                            class="!text-[10px] shrink-0 !bg-transparent"
                            severity="secondary"
                            [value]="getStatusLabel(sale.status)"
                          />
                        </div>
                      </div>
                    }
                    @if (column.loadingMore) {
                      <div class="flex justify-center py-2">
                        <i class="pi pi-spin pi-spinner text-sky-500 text-sm"></i>
                      </div>
                    }
                    @if (!column.loading && column.items.length === 0) {
                      <p class="text-center text-xs text-slate-400 py-6">Sin ventas</p>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

</div>

  <!-- Drawer detalle de Venta -->
  <p-drawer
    [visible]="isDetailsOpen()"
    position="right"
    (visibleChange)="onDrawerVisibleChange($event)"
    styleClass="sale-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-100 text-violet-600 shadow-sm">
            <i class="pi pi-shopping-cart text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de venta</h3>
        </div>
        @if (selectedSale() && !detailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (detailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando detalle...</p>
      </div>
    } @else if (selectedSale()) {
      <app-sale-read
        [sale]="selectedSale()!"
        [charges]="saleCharges()"
        (openCustomer)="openCustomerDetails($event)"
        (openSubscription)="openSubscriptionDetails($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isCustomerDetailsOpen()"
    position="right"
    (visibleChange)="onCustomerDrawerVisibleChange($event)"
    styleClass="customer-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
            <i class="pi pi-user text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalles del cliente</h3>
        </div>
        @if (selectedCustomer() && !customerDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editCustomerFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (customerDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando cliente...</p>
      </div>
    } @else if (selectedCustomer()) {
      <app-customer-read
        [customer]="selectedCustomer()!"
        (openSale)="openSaleDetailsFromCustomer($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isSubscriptionDetailsOpen()"
    position="right"
    (visibleChange)="onSubscriptionDrawerVisibleChange($event)"
    styleClass="subscription-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-100 text-teal-600 shadow-sm">
            <i class="pi pi-sync text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de suscripción</h3>
        </div>
        @if (selectedSubscription() && !subscriptionDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editSubscriptionFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (subscriptionDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-teal-500"></i>
        <p class="text-sm text-slate-600">Cargando suscripción...</p>
      </div>
    } @else if (selectedSubscription()) {
      <app-subscription-read
        [subscription]="selectedSubscription()!"
        (openSale)="openSaleDetailsFromCustomer($event)" />
    }
  </p-drawer>

</div>
